export default __webpack_public_path__ + "static/media/contract_3.ee940c23.jpg";